export const Logo = ({ className = "h-10" }) => (
  <img src="/pos-finder-logo.svg" alt="POS Finder" className={`${className} aspect-square rounded-xl shadow-md shadow-blue-900/20 object-contain`} data-testid="app-logo" />
);

export const Brand = ({ large = false }) => (
  <div className="flex items-center gap-3" data-testid="app-brand">
    <Logo className={large ? "h-14" : "h-10"} />
    <span className={`font-display font-extrabold tracking-tight text-slate-900 whitespace-nowrap ${large ? "text-3xl" : "hidden lg:inline text-xl"}`}>
      POS <span className="text-blue-700">Finder</span>
    </span>
  </div>
);
